
























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

interface Tabs {
  key: string;
  value: string;
  icon?: string;
}

@Component
export default class UiUpdateInfo extends Vue {
  @Prop({ default: [] })
  tabs: Tabs[];

  @Prop({ default: 'accent' })
  activeButtonStyle: string;

  @Prop({ default: 'style-button' })
  styleType: string;

  activeTab: string = this.tabs[0]?.key || ''

  tabBodySlotName(key) {
    return `content-${key}`
  }

  switchTab(tabName) {
    this.activeTab = tabName
    this.$emit('switchTab', tabName)
  }
}
